<template>
  <section class="mt-4">
    <span class="text-gray-500 text-md mb-2">
      Add some text to your narrative! Feel free to use both
      <a href="https://markdowntutorial.com" class="text-blue-500 underline"
        >Markdown</a
      >
      and
      <a href="https://katex.org" class="text-blue-500 underline">KaTex</a> to
      generate rich formatting and include equations.
    </span>

    <label
      for="number-ticks"
      class="block text-sm leading-5 font-medium text-gray-700 mb-2 mt-4"
      >Text</label
    >

    <textarea
      id="text-input"
      @input="changed"
      v-model="element.text"
      class="bg-gray-100 text-gray-500 p-4 w-full border-gray-500 h-36 rounded-md"
    ></textarea>

    <color-form :element="element" @changed="updateCSS"></color-form>

    <!-- ANIMATION FORM -->
    <animation-form :element="element"></animation-form>

    <pin-form :element="element"></pin-form>
  </section>
</template>

<script>
// import Component from "../component_location"
import AnimationForm from "@/components/ElementForm/AnimationForm.vue";
import PinForm from "@/components/ElementForm/PinForm.vue";
import ColorForm from "@/components/ElementForm/ColorForm.vue";
import VSwatches from "vue-swatches";
import { debounce } from "@/utils.js";

export default {
  components: { VSwatches, AnimationForm, ColorForm, PinForm },

  props: ["element"],

  data() {
    return {};
  },

  watch: {
    element: function() {
      this.updateCSS();
    },
  },

  methods: {
    changed() {
      var func = debounce(this.updateCSS, 500);
    },
    updateCSS() {
      $(".markdown p").css("color", this.element.textColor);
      $(".markdown").css("background-color", this.element.backgroundColor);
    },
  },

  computed: {},

  mounted() {
    var applyCSS = debounce(() => {
      this.updateCSS(), 500;
    });
    const text = document.querySelector("#text-input");
    text.addEventListener("keyup", applyCSS);
    this.updateCSS();
  },
};
</script>

<style>
.vue-swatches__trigger {
  border: 1px solid #afafaf;
}
</style>
